import type { PropsWithChildren } from 'react';
import type { RuleSet } from 'styled-components';
import styled from 'styled-components';
import {
  createReadableClass,
  getColorWithAlpha,
  getInvertedColor,
  scrollbarColoredHoverMixin
} from '@elfsight/widget-utils';
import { useCheckoutColors } from '../providers';

export function Scrollable({
  children,
  stretch = false,
  withCustomScrollbar = true
}: PropsWithChildren & { stretch?: boolean; withCustomScrollbar?: boolean }) {
  const { backgroundColor } = useCheckoutColors();

  const thumbColor = getColorWithAlpha(getInvertedColor(backgroundColor), 0.1);
  const thumbHoverColor = getColorWithAlpha(
    getInvertedColor(backgroundColor),
    0.15
  );

  return (
    <Component
      $scrollbarMixin={
        withCustomScrollbar
          ? scrollbarColoredHoverMixin(thumbColor, thumbHoverColor)
          : undefined
      }
      $stretch={stretch}
    >
      {children}
    </Component>
  );
}

const Component = styled.div.attrs<{
  $scrollbarMixin?: RuleSet;
  $stretch?: boolean;
}>({
  className: createReadableClass({
    component: 'scrollable-container'
  })
})`
  width: 100%;
  max-height: 100%;
  overflow: auto;

  ${({ $stretch = false }) => $stretch && 'height: 100%'};
  ${({ $scrollbarMixin }) => $scrollbarMixin};
`;
